import { render, staticRenderFns } from "./SideMenuLanguageSheet.vue?vue&type=template&id=30b99368&"
import script from "./SideMenuLanguageSheet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SideMenuLanguageSheet.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b99368')) {
      api.createRecord('30b99368', component.options)
    } else {
      api.reload('30b99368', component.options)
    }
    module.hot.accept("./SideMenuLanguageSheet.vue?vue&type=template&id=30b99368&", function () {
      api.rerender('30b99368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenuLanguageSheet.vue"
export default component.exports